import { render, staticRenderFns } from "./mehrfachbindung-nachweis.vue?vue&type=template&id=019fd17a&"
import script from "./mehrfachbindung-nachweis.vue?vue&type=script&lang=js&"
export * from "./mehrfachbindung-nachweis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports